import { useEffect, useState } from "react";
import LoadingOverlay from "../../../components/LoadingOverlay";
import { T2 } from "../../../styles/titles";
import {
  FormValues,
  FailedSettlementsTableData,
  TotalsData
} from "./types";
import { Container } from "./styles";
import { FormFilter } from "./components/filter/filter";
import { Totals } from "./components/totals/totals";
import { LiveTable } from "./components/liveTable/liveTable";
import { Button } from "../../terminaisPhoebus/styles";
import SlcFailedSettlementsService from "./service/failedSettlementsService";
import { can, PortalPermissions } from "../../../config/permissions";

const DetalhamentoLiquidacoesFalhasSLC: React.FC = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [tableData, setTableData] = useState<FailedSettlementsTableData | null>(null);
  const [totalsData, setTotalsData] = useState<TotalsData | null>(null);
  const [pageSize, setPageSize] = useState<number>(20);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [filterData, setFilterData] = useState<any>(null);
  const failedSettlementsService = new SlcFailedSettlementsService();

  useEffect(() => {
    if (filterData) {
      setCurrentPage(1);
    }
  }, [filterData]);

  useEffect(() => {
    if (filterData) {
      fetchData();
    }
  }, [filterData, currentPage, pageSize]);

  const fetchData = async () => {
    setIsLoading(true);

    try {
      const data = await failedSettlementsService.getFailedSettlements(
        currentPage,
        pageSize,
        filterData
      );

      setTotalsData({
        totalUnpaidValue: data.totalUnpaidValue || 0,
        totalRows: data.rowCount,
      });

      setTableData({
        records: data.items || [],
        count: data.rowCount || 0,
      });
    } catch (error) {
      console.log("Erro ao buscar os detalhes das liquidações falhas do slc", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleDownload = async (filter?: FormValues) => {
    setIsLoading(true)
    const response = await failedSettlementsService.getFailedSettlementsXlsxDownload(
      filter);

    if (response) {
      const objectUrl = window.URL.createObjectURL(response);
      const a = document.createElement('a');
      a.href = objectUrl;
      a.download = buildXlsxFileName(); // Nome do arquivo
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(objectUrl);
      document.body.removeChild(a);
    }
    setIsLoading(false)
  };

  const buildXlsxFileName = () => {
    const now = new Date();

    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');

    return `LiquidacoesFalhas-${day}-${month}-${year}-${hours}-${minutes}.xlsx`;
  }

  return (
    <Container>
      <LoadingOverlay show={isLoading} relative />

      <T2>Liquidações Falhas</T2>
      {totalsData && <Totals data={totalsData} isAdmin={filterData.isAdmin} />}
      <FormFilter getFilters={(data) => setFilterData(data)} />

      {can(PortalPermissions.slc.liquidacoesFalhas.exportar) && (
        <Button
          onClick={() => {
            handleDownload(filterData);
          }}
          style={{
            marginBottom: '25px',
            marginRight: '24px',
            width: '150px',
            alignSelf: 'start'
        }}
        >
          Download XLSX
        </Button>
      )}
      {tableData && (
        <LiveTable
          data={tableData}
          currentPage={currentPage}
          pageSize={pageSize}
          onPageChange={setCurrentPage}
          onPageSizeChange={setPageSize}
          isAdmin={filterData.isAdmin}
        />
      )}
    </Container>
  );
};

export default DetalhamentoLiquidacoesFalhasSLC;
